export default {
  install(Vue){
    Vue.filter('htmlImage',(v)=>{
      return ""
    })
  }
}